import {useLayoutEffect, useRef} from "react";
import {useCookies} from "react-cookie";

import {URL_ORIGINAL_WEBSITE} from "@/lib/links.ts";

import marketingHeaderHtml from "./marketingHeader.html?raw";

import "./marketingHeader.scss";

const AUTH_COOKIE = "uptime_user_logged_in";

const MarketingHeader = () => {
  const htmlRef = useRef<HTMLDivElement>(null);
  const [cookies] = useCookies([AUTH_COOKIE]);

  useLayoutEffect(() => {
    const timeout = setTimeout(() => {
      if (!htmlRef.current) return;

      // Transform relative paths into absolute paths leading to the original website
      const updatedHtml = marketingHeaderHtml.replace(/href="\/(?!\/)/g, `href="${URL_ORIGINAL_WEBSITE}/`);

      const range = document.createRange();
      range.selectNode(htmlRef.current);
      const documentFragment = range.createContextualFragment(updatedHtml);

      htmlRef.current.innerHTML = "";
      htmlRef.current.append(documentFragment);
      document.dispatchEvent(new Event("DOMContentLoaded"));
    }, 0);

    return () => {
      clearTimeout(timeout);
    };
  }, [cookies.uptime_user_logged_in]);

  return <div className="marketingHeaderWrapper" ref={htmlRef} />;
};

export default MarketingHeader;
